import { getBoundaryColourByLevel } from '@/helpers/colour';

const formatter = 'relativeTimeChart';

/**
 * Format the resultData and relevanceData into display data that can be passed into
 * <dp-chart>
 */
export default function formatRelativeTimeChart(kpi, result) {
  const displayType = kpi.getDisplayType();
  const displayData = {
    key: 'Data 1',
    values: [],
    type: displayType,
  };

  const { data, meta: { typeY0 } } = result;
  const { displayOptions: { displayBoundaries, hideLineMarkers } } = kpi;

  const displayColours = displayType !== 'line'
    && ((typeY0 === 'percentage' && displayBoundaries === undefined)
      || displayBoundaries === true);

  if (displayType === 'line') {
    displayData.mode = hideLineMarkers ? 'lines' : 'lines+markers';
  }

  const points = data.map(({
    x, y0, level0,
  }) => ({
    x,
    y: typeY0 === 'percentage' ? y0 / 100 : y0,
    colour: level0 && displayColours
      ? getBoundaryColourByLevel(level0)
      : undefined,
  }));

  displayData.values = points;
  return {
    displayType,
    displayData,
    isPercent: kpi.isPercent(),
    formatter,
  };
}
